import { SpeechBubbleFill18Icon } from "@vygruppen/spor-icon-react";
import { format } from "date-fns";
import type { MuteHistoryEntry } from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/useEventCardState";
import { type ColorScheme } from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/types";
import DashedLine from "features/CenterContent/VehicleDetails/shared/DashedLine";
import { FC } from "react";
import { Box, Flex, Text, tokens } from "shared/components/Spor";

type MuteHistoryBoxProps = {
  muteHistory: MuteHistoryEntry[];
  colorScheme: ColorScheme;
  hover?: boolean;
};

const formatEntryLabel = (entry: MuteHistoryEntry) => {
  const date = new Date(entry.timestamp);
  const timeString = format(date, "HH:mm");

  if (entry.action === "muted") {
    return `Dempet ${timeString}`;
  }

  return `Fremhevet ${timeString}`;
};

export const MuteHistoryBox: FC<MuteHistoryBoxProps> = ({
  muteHistory,
  colorScheme,
  hover,
}) => {
  if (!muteHistory || muteHistory.length === 0) {
    return null;
  }

  return (
    <Box width="100%">
      {muteHistory.toReversed().map((entry, index) => (
        <Box key={`${entry.timestamp}`}>
          {index > 0 ? (
            <DashedLine
              color={
                hover
                  ? colorScheme.backgroundColor
                  : colorScheme.backgroundColorHover
              }
              paddingX={tokens.default.size.spacing[5]}
            />
          ) : null}

          <Box
            backgroundColor={
              hover
                ? colorScheme.backgroundColor
                : colorScheme.backgroundColorHover
            }
            width="100%"
            p={tokens.default.size.spacing[2]}
            borderRadius={tokens.default.size.spacing[1]}
          >
            <Flex gap={tokens.default.size.spacing[1]} alignItems="center">
              <SpeechBubbleFill18Icon color={colorScheme.textColorSecondary} />
              <Text
                variant="xs"
                color={colorScheme.textColorSecondary}
                fontWeight="bold"
              >
                {formatEntryLabel(entry)}
              </Text>
            </Flex>
            {entry.reason ? (
              <Text
                variant="xs"
                fontWeight="normal"
                color={colorScheme.textColorMain}
                mt={tokens.default.size.spacing[1]}
                textAlign="start"
              >
                {entry.reason}
              </Text>
            ) : null}
          </Box>
        </Box>
      ))}
    </Box>
  );
};
